import { registerProvider } from './index';

class ConsoleProvider {
  name = 'console';
  prefix = '[analytics]';

  initialize(config) {
    if (config?.prefix) this.prefix = config.prefix;
  }

  track(event, properties) {
    console.log(`${this.prefix} TRACK ${event}`, properties);
  }

  identify(userId, traits) {
    console.log(`${this.prefix} IDENTIFY ${userId}`, traits);
  }

  pageView(page, properties) {
    console.log(`${this.prefix} PAGE ${page}`, properties);
  }

  revenue(event, amount, currency, properties) {
    console.log(`${this.prefix} REVENUE ${event} ${amount / 100} ${currency}`, properties);
  }

  timing(page, durationMs) {
    console.log(`${this.prefix} TIMING ${page} ${durationMs}ms`);
  }

  setConsent(consent) {
    console.log(`${this.prefix} CONSENT`, consent);
  }

  flush() {}
  shutdown() { console.log(`${this.prefix} shutdown`); }
  reset() {}
  isHealthy() { return true; }
}

registerProvider('console', ConsoleProvider);
export default ConsoleProvider;
